<template>
  <CCard>
    <CCardHeader>
      {{ $t("CCR Group") }}
    </CCardHeader>
    <CCardBody>
      <CRow class="flex justify-content-between align-items-center">
        <MzSelect
          class="mb-3 col-3"
          :options="coveryear_ids"
          :value.sync="selected_coveryear_id"
          @update:value="onSelectChange"
        />
        <div class="col-3"></div>
        <CButton
          v-if="hasAccessComplete"
          class="mz-button justify-content-center align-items-end v2-mz-btn mr-2 col-3"
          color="primary"
          @click="downloadFile('Cover_Year_Group_CCR.xlsx')"
          :disabled="!hasAccessAdmin()"
        >
          <span>
            {{ $t("Download") }}
            <em class="ml-2 mz-icon icon-download color-inherit" />
          </span>
        </CButton>
      </CRow>

      <table-component
        :key="selected_coveryear_id"
        :url="filteredUrl"
        ref="filesTable"
        :columns="filteredColumns"
        :tableDateFormat="$options.dateFormat"
        :headings="tableHeadings"
        defaultOrderBy=""
      >
      </table-component>
    </CCardBody>
  </CCard>
</template>

<script>
import AddButton from "@/components/AddButton";
import { COVERYEARS_ENDPOINTS, CoverYearServices } from "@/services/coveryears";
import { ActiveUser } from "@/services/user";
import { userRoles } from "../../constants/userRoles";
import {downloadFile} from "@/utils/request";

export default {
  name: "FileList",
  components: { AddButton },
  data() {
    return {
      COVERYEARS_ENDPOINTS,
      CoverYearServices,
      coveryear_ids: [],
      selected_coveryear_id: null,
      group_ccr_data: {},
      tableHeadings: {
        group_ccr: this.$t("CCR Group"),
        name: this.$t("Member"),
      },
    };
  },
  computed: {
    filteredColumns() {
      return Object.keys(this.tableHeadings).filter(
        (col) => col !== "id_coveryear"
      );
    },
    filteredUrl() {
      const baseUrl = COVERYEARS_ENDPOINTS.coveryear_CCR_group;
      const params = new URLSearchParams();

      if (this.selected_coveryear_id) {
        params.append("id_coveryear", this.selected_coveryear_id);
      }

      const queryString = params.toString();
      return queryString ? `${baseUrl}?${queryString}` : baseUrl;
    },
    hasAccessComplete() {
      return !ActiveUser.isSuperUser();
    },
  },
  async mounted() {
    const { data } = await this.$request({
      url: COVERYEARS_ENDPOINTS.coveryear_CCR_group,
    });
    this.group_ccr_data = data;
    let duplicates_coveryear_ids = this.group_ccr_data.map((item) => item.id_coveryear);
    let set_coveryear_ids = new Set(duplicates_coveryear_ids);
    this.coveryear_ids = [...set_coveryear_ids]
    ;
  },
  methods: {
    async onSelectChange(coveryear_id) {
      this.selected_coveryear_id = coveryear_id;
      this.$refs.filesTable.reload?.();
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    hasAccessAdmin() {
      return ActiveUser.hasRole(userRoles.Admin);
    },
    isSuperUser() {
      return ActiveUser.user.role === userRoles.SuperUser;
    },
    async downloadFile() {
      this.$downloadFile({
        downloadFileName: 'Cover_Year_Group_CCR.xlsx',
        url: COVERYEARS_ENDPOINTS.download_coveryear_CCR_group,
        query: {
          language: this.$store.state.language
        }
      })
    }
  },
};
</script>
